"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const GeometryVisualization = () => {
    return (react_1.default.createElement("div", { className: "geometry-visualization" },
        react_1.default.createElement("div", { className: "visualization-header" },
            react_1.default.createElement("h1", null, "Geometry Visualizations"),
            react_1.default.createElement("p", null, "Explore fundamental geometric concepts through interactive shape manipulations.")),
        react_1.default.createElement("div", { className: "explanation", style: {
                marginTop: '40px',
                padding: '20px',
                background: '#1e293b',
                borderRadius: '8px'
            } },
            react_1.default.createElement("h3", { style: { marginBottom: '15px', color: '#f8fafc' } }, "What am I looking at?"),
            react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0' } }, "This visualization explores fundamental geometric concepts through interactive demonstrations. Key concepts include:"),
            react_1.default.createElement("ul", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } },
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Polygons"),
                    ": Regular and irregular shapes with different side counts"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Transformations"),
                    ": Rotations, translations, and scaling of shapes"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Symmetry"),
                    ": Reflectional and rotational symmetry patterns"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "3D Shapes"),
                    ": Polyhedrons and their properties"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("strong", null, "Geometric Proofs"),
                    ": Visual demonstrations of theorems")),
            react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } }, "Interact with the visualizations to explore how geometric principles apply to different shapes."))));
};
exports.default = GeometryVisualization;
